var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "agreement" },
    [
      _c(
        "a",
        {
          on: {
            click: function($event) {
              _vm.isShow = true
            }
          }
        },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShow,
            title: _vm.title,
            width: "900px",
            "before-close": _vm.close
          },
          on: {
            "update:visible": function($event) {
              _vm.isShow = $event
            }
          }
        },
        [
          _c("div", [
            _vm.type == 1
              ? _c("div", { staticClass: "agreement-con" }, [
                  _c("h1", [_vm._v("沈阳麟龙公募基金投资准入要求")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "为了您更正确、全面地了解网上基金交易风险，希望您仔细阅读下面的内容。如果您同意下面的风险说明，我们即认为您已经完全了解基金交易的风险性，并能够承担网上基金交易可能带来的损失，符合购买基金的合格投资者准入要求。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "基金投资类似股票，不能保证盈利，且有可能带来亏损。要求购买基金产品的投资者具备一定的风险识别能力和风险承担能力，最好有一定的证券投资经验。有较好的心理素质，能正确面对投资亏损，不会因亏损做出极端事项。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "基金投资需要一定的资金，特别一些专户产品，有最低购买金额的限制，请确保您在基金交易时有足够的资金。同时，您的资产规模或收入水平，能满足基金投资需要，不要影响到您的正常生活。比如，您持有的金融资产不低于5万元，或者最近三年个人年均收入不低于5万元。此处所称金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "根据《证券期货投资者适当性管理办法》规定，我司会组建投资者评估数据库，为您建立信息档案，并对您的风险承受能力进行动态管理，在充分了解您的信息与风险评估结果后，给出合理的交易匹配性意见。因此请确保您填写的信息真实、有效、完整，在您的个人信息发生重大变化后，也请告知我司。如果有合理依据确认您提供的信息不真实、不准确、或不完整，我司有权拒绝向您销售产品或提供服务，由此造成的损失，也将由您自行承担。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "购买基金产品前需要投资者填写风险调查问卷，请按真实情况填写，以便我司更全面的了解您的投资意向，为您推介合适的产品。基金购买流程中，会对您的风险承受能力与产品风险等级做匹配校验，如出现超风险购买行为，我司会进行风险警示，请认真阅读、慎重考虑并选择相应的操作。"
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.type == 2
              ? _c("div", { staticClass: "agreement-con" }, [
                  _c("h1", [_vm._v("沈阳麟龙网上交易协议")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v("甲方："),
                    _c("br"),
                    _vm._v("乙方：财咨道信息技术有限公司")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "为了方便甲方在乙方办理基金交易业务，甲乙双方依据有关法律、法规的规定，本着公开、公平、自愿和诚实信用的原则，就乙方为甲方提供网上交易服务及其他相关服务达成如下协议： "
                    )
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v("第一条 释义"), _c("br")]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "除本协议另有规定外，下列用语在本协议中具有如下含义： "
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "1、网上交易：指甲方通过乙方网上交易系统进行开放式基金交易、信息查询或其他相关业务的交易方式。 "
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "2、基金交易账户：指乙方为甲方开立的，记录其通过乙方进行交易的开放式基金份额的变动及结余情况的账户。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "3、基金账户：指基金注册登记机构为投资者开立的，记录其持有开放式基金基金份额、份额变更情况及基本资料的账户。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "4、基金账号登记：如甲方在乙方以外的其他基金销售机构开立基金账户后，需在乙方办理开放式基金业务时，应首先登记基金账号。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "5、认购：指开放式基金募集发售期内，投资者申请购买基金份额的行为。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "6、申购：指开放式基金合同生效后，投资者申请购买基金份额的行为。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "7、赎回：指基金份额持有人按基金合同规定的条件要求基金管理人购回基金份额的行为。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "8、基金转换：指基金份额持有人将其所持有的基金份额转换成同一注册登记人登记的同一基金管理公司的其它基金的基金份额的行为。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "9、基金份额转托管转入：指基金份额持有人将其持有的基金份额从其它基金销售机构的交易账户转到在乙方开立的交易账户进行交易的行为。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "10、分红方式变更：指变更红利发放方式的行为，红利发放可以采用现金分红方式或红利再投资方式。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "11、交易撤单：指将已生效的委托在规定时间内进行撤销的行为。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "12、账户资料修改：指甲方修改其在乙方系统记录的个人联系信息及其它可修改信息的行为。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "13、工作日：指上海证券交易所、深圳证券交易所的正常交易日。"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v("第二条 网上交易服务的内容"), _c("br")]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "1. 本协议所述网上交易服务包括基金交易账户开户、基金账户开户、基金账户登记、银行账户变更、账户资料修改、认购、申购、赎回、基金份额转托管转入、基金转换、分红方式变更、交易撤单和查询等业务的服务。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "2. 甲方的认购、申购、赎回、基金转换等交易行为应按照基金合同和基金招募说明书的有关规定缴纳相应的费用，并应承担因上述交易行为发生的资金划付费用等银行相关费用。 "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v("第三条 网上交易风险提示 "), _c("br")]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "1、基金投资存在损失本金的风险，甲方申请使用乙方网上交易系统进行基金交易将被认为已经完全了解基金投资的风险，并能够承担由此可能带来的损失。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "2、乙方已最大限度地采取了合理措施保护甲方资料和交易活动的安全。尽管如此，本着对客户负责的态度，乙方在此郑重提示甲方进行网上交易仍然存在风险。该风险包括但不限于："
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "（1）互联网是全球公共网络，并不受任何一个机构所控制。数据在互联网上传输的途径不是完全确定的，可能会受到非法干扰或侵入。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "（2）在互联网上传输的数据有可能被某些个人、团体或机构通过某种渠道获得或篡改。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "（3）互联网上的数据传输可能因通信繁忙出现延迟，或因其他原因出现中断、停顿或数据不完全、数据错误等情况，从而使交易出现延迟、停顿或中断。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "（4）互联网上发布的各种信息，包含但不限于分析、预测性资料等，均可能出现错误或发生误导。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v("（5）甲方的网上交易身份可能会被仿冒。")
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "（6）甲方自身所使用计算机的性能、质量、病毒、故障或其他原因可能对甲方的交易时间或交易数据造成影响，因此给甲方造成损失。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "（7）甲方计算机应用操作能力或互联网知识方面的缺乏，可能对甲方的交易时间或交易数据造成影响，因此给甲方造成损失。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "（8）因甲方自身的疏忽造成的账户信息或密码（包括但不限于交易密码或银行卡支付密码，以下同）泄漏可能会给甲方造成损失。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v("（9）因不可抗力事件导致的其他网上交易风险。")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [
                      _vm._v("第四条 甲方在此作出以下声明、保证和承诺"),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "1、甲方声明：已按照乙方的要求在乙方开立了基金交易账户，并已作出以下承诺：“本人/本机构为中华人民共和国法律法规以及各基金合同规定的合法投资者。”"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "2、甲方声明：自愿通过乙方的网上交易系统办理基金业务并同意：任何登录乙方网上交易系统所进行的网上交易行为均应被视同为甲方亲临乙方柜台办理相应的基金业务。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "3、甲方声明：在签订本协议之前已经详细阅读了本协议全部规定，包括乙方免责规定，准确理解了其含义，清楚地了解了使用网上交易可能遭受的各种风险。甲方自愿承担因此类风险导致的任何损失，不对因此类风险导致的任何损失向乙方请求赔偿。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "4、甲方声明：在签订本协议之前已详细阅读、理解并接受乙方所代销的开放式基金的《基金合同》、《招募说明书》、更新的招募说明书及相关业务规则的全部规定。充分了解了基金投资的规则和风险，在购买基金前已充分考虑了自身的年龄、经济实力、投资目的、投资期限、收益预期和风险承受能力等情况，客观评估了自身的风险承受能力，认真确定了自身的投资目标和策略，并挑选了与自身风险承受能力相匹配的基金产品。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "5、甲方保证：用于投资的资金来源及用途合法，并承诺自行承担因违反本条规定引起的一切法律责任和全部赔偿责任。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "6、甲方保证：在任何情况下根据乙方要求所填写的信息，包括但不限于登录乙方网上交易系统时填写的姓名、身份证件号码、银行卡号等相关信息，是真实、准确和有效的。如所填写信息发生变化，甲方将及时办理相关信息及资料的变更。甲方承诺，因甲方提供不真实、错误或无效信息，或因未能及时变更相关信息和资料所导致的任何损失，由甲方自行承担；如因此导致对乙方或其他任何第三方的损失，亦由甲方承担全部赔偿责任。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "7、甲方有权且仅有权根据本协议的规定，以甲方自身的名义并为甲方自身之利益登录乙方网上交易系统，进行网上交易。甲方承诺，不以其自身名义通过网上交易系统代理任何其他第三方进行基金交易或从中收取任何费用，亦不应允许任何其他人以甲方的名义通过乙方网上交易系统进行网上交易，否则均视为甲方自身之行为，由此产生的任何风险和责任均由甲方自行承担，与乙方无关。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "8、甲方承诺：对自己的账户信息和密码认真履行保密义务，采取合理措施保护自己的账户信息和密码。因任何甲方原因导致账户信息或密码泄露给甲方造成损失，甲方承担全部责任。甲方采取的保密措施包括但不限于："
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v("（1）定期更换密码；")
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "（2）不将账户信息和密码记载在任何他人可以看到的载体上；"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v("（3）不将账户信息和密码告知任何第三方；")
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "（4）发现或有理由认为自己的网上交易账户信息和密码已经或可能被第三方获取或使用，立即修改密码或采取其他防范措施。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "甲方在此同意并确认，通过甲方账号，使用甲方密码提交的一切网上交易申请均应被视为甲方本人/本机构提出并亲自办理的有效交易申请，乙方可以充分信赖该等交易申请而受理，甲方承认该等申请及其所有结果对甲方具有约束力。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "9、甲方注册乙方交易账户即视为甲方授权乙方通过乙方指定的支付机构按照甲方在乙方平台上的交易申请金额从乙方银行账户主动进行交易资金的代收扣收，用于完成乙方的投资资金交付。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "10、为保护甲方交易数据的安全，甲方在进行网络交易时应使用乙方指定的浏览器。甲方承诺，因使用不符合要求的其他软件或设备进入乙方网站而引起的任何损失、损害或其他任何后果，均由甲方自行承担，乙方不需对此承担任何责任。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "11、甲方承诺：确保用于网上交易的甲方设备的安全性和可靠性，并自行承担因甲方设备故障及通讯故障等原因造成的任何损失，乙方不需对此承担任何责任。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "12、甲方承诺：不将本协议项下的权利或义务部分或全部地转让给任何第三方"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "13、甲方承诺：不以任何方式从事任何可能对乙方网站或其网上交易系统造成损害的行为，违反本条规定给乙方或任何其他第三方造成损害或损失，甲方承担全部赔偿责任。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "14、甲方承诺：对因甲方违约行为导致乙方遭受的任何损失承担全部赔偿责任。"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v("第五条 乙方承诺"), _c("br")]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "1、乙方将严格遵守所适用的法律法规，并接受本协议所有条款的约束。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "2、乙方网上交易系统的系统安全、数据备份和故障恢复措施符合监管机关的规定。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "3、乙方将采取先进的网络产品和合理有效的技术措施，最大限度地保护客户资料和交易活动的安全。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "4、对甲方的网上交易行为，乙方将保留相关电子数据作为甲方交易行为的证明，对甲方的委托资料、委托事项、密码及其他在乙方登记的资料履行保密义务，未经甲方许可不向任何人透露，但乙方按照有关法律、法规规定或有关司法机关、行政管理机关的要求提供甲方有关资料的行为除外。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "5、乙方在本协议生效当日为甲方开通本协议约定的交易委托方式。 "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v("第六条 提示条款"), _c("br")]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "1、本协议的签署：甲方需在办理网上基金交易账户开户业务、网上交易业务前签署订本协议。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "2、网上基金交易账户开户、银行账户变更业务：在办理甲方网上基金交易账户开户或银行账户变更业务时，乙方会通过相关合作方对甲方的身份信息、银行账户信息进行核对，核对结果以合作方提供的确认信息为准。如因合作方提供的确认信息有误，导致甲方不能正常办理前述业务的，乙方对此不承担任何责任。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "3、支付业务提示：甲方须依据乙方业务规则及相关业务指南办理资金支付事宜。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "4、设备提示：甲方应有本协议约定的，网上交易所必需的设备。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "5、密码提示：甲方在登录网上交易时必须录入登录密码，在进行网上交易时必须录入交易密码。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [_vm._v("6、交易提示：")]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "(1)甲方通过网上交易方式下达的交易申请以乙方网上交易系统的记录为准。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "(2)甲方使用网上交易方式办理基金业务，需自行支付因此产生的相关费用，包括但不限于上网费、甲方发起的银行划款手续费等。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "(3)乙方受理的甲方各类需要注册登记机构确认的基金业务申请，以注册登记机构确认的结果为准。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "7、交易受理时间提示： 基金当日交易申请的受理截止时间为15：00，如在当日15：00后提交交易申请，则该交易申请将作为下一个工作日的交易申请处理。交易申请的提交时间以乙方网上交易系统自动记载时间为准。 "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v("第七条 免责条款"), _c("br")]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "双方特别约定，乙方对以下情形以及以下情形导致的损失不承担责任："
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "1、因战争、自然灾害、罢工、不可控制的流行疾病、地震、火灾、台风及其他各种不可抗力事件引起的停电、网络系统故障及电脑故障。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "2、因电信部门的通讯线路故障、通讯技术缺陷、电脑黑客或计算机病毒等原因造成的交易系统不能正常运转。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "3、因法律、政策发生重大变化，或乙方不可预测、不可控制的因素引起突发事件导致甲方损失的。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "4、因技术问题（包括但不限于电脑软件、通讯、网络传输等故障）引起的交易失败导致甲方损失的。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "5、因银行划付等业务故障引起的交易失败导致甲方损失的。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "6、因甲方设备或通讯故障或设备未能处于正常工作状态致使乙方未能按时或及时收到甲方的申请信息，或者乙方收到的甲方申请信息不完整，从而导致甲方损失的。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "7、因甲方对设备的错误操作和对有关信息的错误理解导致甲方损失的。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "8、乙方对甲方所有的网上交易申请仅进行表面真实性审核。通过甲方账号、密码提交的网上交易申请，只要通过表面真实性审核，乙方均可确认为甲方本人/本机构提出，给予充分信赖而进行受理。甲方由于自身疏忽或其他非乙方原因导致账户信息或密码（包括但不限于交易密码或银行卡支付密码）失密，并因此受到损失，应自行承担，乙方不需对此承担任何责任。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "9、法律规定和本协议约定的其他免除乙方责任的事项。"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v("第八条 协议生效及变更"), _c("br")]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "1、本协议自甲方在乙方网上交易系统中对本协议予以确认之日起生效。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "2、在不损害甲方利益的前提下，乙方享有修改或增补本协议内容的权利。本协议的修改通知以书面形式公告于乙方网站及营业场所，或以其他乙方认为可行的方式通知。甲方在修改通知公布或通知之日起三十日内未向乙方提出书面异议则视同乙方对本协议的修改已经得到甲方的同意和认可。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        "3、本协议生效后，若有关法律、法规、行政规章、《基金合同》、《招募说明书》及其他乙方和甲方应共同遵守的文件发生修订，本协议中与之不相符合的规定自行失效，但本协议的其他规定继续有效。"
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [_vm._v("4、本协议在下述情况之一发生时终止： ")]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v("(1) 双方签订书面协议同意终止。")
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v("(2) 甲方死亡或不再具备相应的民事行为能力。")
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v("(3) 甲方撤销在乙方开立的交易账户。")
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v("(4) 甲方取消网上交易方式。")
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v("(5) 因不可抗力事件致使本协议无法继续履行。 ")
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "sub" }, [
                      _vm._v(
                        "(6) 一方违约，守约方有权书面通知违约方终止本协议，本协议自书面通知发出之日起终止。 "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v("第九条 争议的解决 "), _c("br")]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        " 甲、乙双方因解释或履行本协议发生争议应尽可能通过协商解决。协商不成，任何一方均有权向沈阳仲裁委员会申请仲裁，并按照该委员会届时有效的仲裁规则进行仲裁，仲裁地点在沈阳。仲裁裁决是终局的，对双方均有法律约束力。"
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.type == 3
              ? _c("div", { staticClass: "agreement-con" }, [
                  _c("h1", [_vm._v("沈阳麟龙投资者权益须知")]),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "ti0",
                      staticStyle: { "margin-bottom": "20px" }
                    },
                    [
                      _vm._v("尊敬的基金投资人： "),
                      _c("br"),
                      _vm._v(
                        "\n                基金投资在获取收益的同时存在投资风险。为了保护您的合法权益，请在投资基金前认真阅读以下内容："
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-tit",
                      attrs: { slot: "tit" },
                      slot: "tit"
                    },
                    [_vm._v("一、基金的基本知识")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-con",
                      attrs: { slot: "con" },
                      slot: "con"
                    },
                    [
                      _c("span", { staticClass: "t" }, [
                        _vm._v("（一）什么是基金")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        证券投资基金（简称基金）是指通过发售基金份额，将众多投资者的资金集中起来，形成独立财产，由基金托管人托管，基金管理人管理，以投资组合的方法进行证券投资的一种利益共享、风险共担的集合投资方式。\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "t" }, [
                        _vm._v(
                          "（二）基金与股票、债券、储蓄存款等其它金融工具的区别"
                        )
                      ]),
                      _vm._v(" "),
                      _c("table", { staticClass: "table" }, [
                        _c("tr", [
                          _c("th"),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "20%" } }, [
                            _vm._v("基金")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "20%" } }, [
                            _vm._v("股票")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "20%" } }, [
                            _vm._v("债券")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "20%" } }, [
                            _vm._v("银行储蓄存款")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("反映的经济关系不同")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "信托关系，是一种受益凭证，投资者购买基金份额后成为基金受益人，基金管理人只是替投资者管理资金，并不承担投资损失风险"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "所有权关系，是一种所有权凭证，投资者购买后成为公司股东"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "债权债务关系，是一种债权凭证，投资者购买后成为该公司债权人"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "表现为银行的负债，是一种信用凭证，银行对存款者负有法定的保本付息责任"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("所筹资金的投向不同")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v("间接投资工具，主要投向股票、债券等有价证券")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v("直接投资工具，主要投向实业领域")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("直接投资工具，主要投向实业领域")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v("间接投资工具，银行负责资金用途和投向")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("投资收益与风险大小不同")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "投资于众多有价证券，能有效分散风险，风险相对适中，收益相对稳健"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v("价格波动性大，高风险、高收益")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v("价格波动较股票小，低风险、低收益")
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "银行存款利率相对固定，损失本金的可能性很小，投资比较安全"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("收益来源")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("利息收入、股利收入、资本利得")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("股利收入、资本利得")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("利息收入、资本利得")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("利息收入")])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("投资渠道")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v("基金管理公司及银行、证券公司等代销机构")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v("证券公司")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v("债券发行机构、证券公司及银行等代销机构")
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v("银行、信用社、邮政储蓄银行")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "t" }, [
                        _vm._v("（三）基金的分类")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        1、依据运作方式的不同，可分为封闭式基金与开放式基金。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        封闭式基金是指基金份额在基金合同期限内固定不变，基金份额可以在依法设立的证券交易所交易，但基金份额持有人不得申请赎回的一种基金运作方式。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        开放式基金是指基金份额不固定，基金份额可以在基金合同约定的时间和场所进行申购和赎回的一种基金运作方式。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        2、依据投资对象的不同，可分为股票基金、债券基金、货币市场基金、混合基金"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        根据《证券投资基金运作管理办法》对基金类别的分类标准,60%以上的基金资产投资于股票的为股票基金；80%以上的基金资产投资于债券的为债券基金；仅投资于货币市场工具的为货币市场基金；投资于股票、债券和货币市场工具，但股票投资和债券投资的比例不符合股票基金、债券基金规定的为混合基金。这些基金类别按收益和风险由高到低的排列顺序为：股票基金、混合基金、债券基金、货币市场基金，即股票基金的风险和收益最高，货币市场基金的风险和收益最低。"
                        ),
                        _c("br"),
                        _vm._v("\n                        3、特殊类型基金"),
                        _c("br"),
                        _vm._v(
                          "\n                        （1）系列基金。又被称为伞型基金，是指多个基金共用一个基金合同,子基金独立运作,子基金之间可以进行相互转换的一种基金结构形式。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        （2）保本基金。是指通过采用投资组合保险技术,保证投资者的投资目标是在锁定下跌风险的同时力争有机会获得潜在的高回报。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        （3）交易型开放式指数基金(ETF)与上市开放式基金(LOF)。交易型开放式指数基金,通常又被称为交易所交易基金(Exchange Traded Funds,简称“ETF”),是一种在交易所上市交易的、基金份额可变的一种开放式基金。上市开放式基金(Listed Open-ended Funds,简称“LOF”)是一种既可以在场外市场进行基金份额申购赎回，又可以在交易所（场内市场）进行基金份额交易、申购或赎回的开放式基金。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        （4）QDII基金。是一种以境外证券市场为主要投资区域的证券投资基金，投资者可以用人民币或美元等外汇进行认购和申购，在承担境外市场相应投资风险的同时获取相应的投资收益。QDII基金与普通证券投资基金的最大区别在于投资范围不同。\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "t" }, [
                        _vm._v("（四）基金评级")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        基金评级是依据一定标准对基金产品进行分析从而做出优劣评价。投资人在投资基金时，可以适当参考基金评级结果，但切不可把基金评级作为选择基金的唯一依据。此外，基金评级是对基金管理人过往的业绩表现做出评价，并不代表基金未来长期业绩的表现。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        本公司将根据销售适用性原则，对基金管理人进行审慎调查，并对基金产品进行风险评价。\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "t" }, [
                        _vm._v("（五）基金费用")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        基金费用一般包括两大类：一类是在基金销售过程中发生的由基金投资人自己承担的费用，主要包括认购费、申购费、赎回费和基金转换费。这些费用一般直接在投资人认购、申购、赎回或转换时收取。其中申购费可在投资人购买基金时收取，即前端申购费；也可在投资人卖出基金时收取，即后端申购费，其费率一般按持有期限递减。另一类是在基金管理过程中发生的费用，主要包括基金管理费、基金托管费、信息披露费等，这些费用由基金承担。对于不收取申购、赎回费的货币市场基金和部分债券基金，还可按不高于2.5‰的比例从基金资产中计提一定的销售服务费。\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-tit",
                      attrs: { slot: "tit" },
                      slot: "tit"
                    },
                    [_vm._v("二、基金份额持有人的权利")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-con",
                      attrs: { slot: "con" },
                      slot: "con"
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "根据《证券投资基金法》第70条的规定，基金份额持有人享有下列权利："
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        (一)分享基金财产收益；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        (二)参与分配清算后的剩余基金财产；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        (三)依法转让或申请赎回其持有的基金份额；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        (四)按照规定要求召开基金份额持有人大会；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        (五)对基金份额持有人大会审议事项行使表决权；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        (六)查阅或者复制公开披露的基金信息资料；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        (七)对基金管理人、基金托管人、基金份额发售机构损害其合法权益的行为依法提起诉讼；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        (八)基金合同约定的其它权利。\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-tit",
                      attrs: { slot: "tit" },
                      slot: "tit"
                    },
                    [_vm._v("三、基金投资风险提示")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-con",
                      attrs: { slot: "con" },
                      slot: "con"
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "（一）证券投资基金是一种长期投资工具，其主要功能是分散投资，降低投资单一证券所带来的个别风险。基金不同于银行储蓄和债券等能够提供固定收益预期的金融工具，投资人购买基金，既可能按其持有份额分享基金投资所产生的收益，也可能承担基金投资所带来的损失。"
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "（二）基金在投资运作过程中可能面临各种风险，既包括市场风险，也包括基金自身的管理风险、技术风险和合规风险等。巨额赎回风险是开放式基金所特有的一种风险，即当单个交易日基金的净赎回申请超过基金总份额的百分之十时，投资人将可能无法及时赎回持有的全部基金份额。"
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "（三）基金投资人应当充分了解基金定期定额投资和零存整取等储蓄方式的区别。定期定额投资是引导投资人进行长期投资、平均投资成本的一种简单易行的投资方式，但并不能规避基金投资所固有的风险，不能保证投资人获得收益，也不是替代储蓄的等效理财方式。"
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "（四）基金管理人承诺以诚实守信、勤勉尽责的原则管理和运用基金资产，但不保证旗下基金一定盈利，也不保证最低收益。旗下基金的过往业绩及其净值高低并不预示其未来业绩表现。基金管理人提醒投资人基金投资的“买者自负”原则，在做出投资决策后，基金运营状况与基金净值变化引致的投资风险，由投资人自行负担。"
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "（五）本公司将对基金投资人的风险承受能力进行调查和评价，并根据基金投资人的风险承受能力推荐相应的基金品种，但本公司所做的推荐仅供投资人参考，投资人应根据自身风险承受能力选择基金产品并自行承担投资基金的风险。"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-tit",
                      attrs: { slot: "tit" },
                      slot: "tit"
                    },
                    [_vm._v("四、服务内容和收费方式")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-con",
                      attrs: { slot: "con" },
                      slot: "con"
                    },
                    [
                      _c("p", [_vm._v("本公司向基金投资人提供以下服务：")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        (一)对基金投资人的风险承受能力进行调查和评价。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        (二)基金销售业务，包括基金（资金）账户开户、基金申（认）购、基金赎回、基金转换、定额定投、修改基金分红方式等。本公司根据每只基金的发行公告及基金管理公司发布的其它相关公告收取相应的申（认）购、赎回费和转换费。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        (三)基金网上交易服务。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        (四)基金投资咨询服务。"
                        ),
                        _c("br"),
                        _vm._v("\n                        (五)电话咨询服务。"),
                        _c("br"),
                        _vm._v(
                          "\n                        (六)基金知识普及和风险教育。\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "（以上服务内容涉及收费的，以基金销售机构明示收费方式为准。）"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-tit",
                      attrs: { slot: "tit" },
                      slot: "tit"
                    },
                    [_vm._v("五、基金交易业务流程")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-con",
                      attrs: { slot: "con" },
                      slot: "con"
                    },
                    [
                      _c("span", { staticClass: "t" }, [
                        _vm._v(
                          "投资人基金业务主要包括开户、认购、申购、赎回等业务环节。"
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "t" }, [_vm._v("（一）开户")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        基金账户是基金注册登记机构为基金者开立的，用于记录其持有的基金份额余额和变动情况的账户。开户是指投资人经由公司前台业务系统或自助式前台业务系统，通过基金销售支付结算机构认证实名制后，开立基金注册登记机构基金账户的业务过程。在开立基金账户前，投资人须开立结算账户，也就是一般意义上的银行账户。基金投资人结算账户用于投资人认购、申购、赎回基金份额以及分红、无效认（申）购的资金退款等资金结算所用。基金账户开户操作步骤:\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        1、登录公司自助式前台业务系统；"
                        ),
                        _c("br"),
                        _vm._v("\n                        2、打开开户连接；"),
                        _c("br"),
                        _vm._v(
                          "\n                        3、输入需要进行身份认证的信息，包括姓名，证件类型，证件号码，银行卡号等，开始基金销售支付结算机构身份认证；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        4、提交基金销售支付结算机构进行身份认证；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        5、认证通过，填写账户资料；"
                        ),
                        _c("br"),
                        _vm._v("\n                        6、输入交易密码；"),
                        _c("br"),
                        _vm._v(
                          "\n                        7、开户成功。\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "t" }, [
                        _vm._v("（二）认购/申购")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        认购是指购买在首次发行募集期内基金的行为。申购是指在基金首次发行募集结束后投资人日常申请购买基金的行为。一般情况下，基金认购/申购申请一经提交，不得撤销。投资人T日提交认购申请后，一般可于T+2日后查询认购/申购申请的受理情况。投资人在提交认购申请后应及时到原认购网点打印认购成交确认情况。公司对认购/申购申请的受理并不表示对认购/申购申请的成功确认，而仅代表公司确实接受了认购/申购申请。申请的成功确认应以基金注册登记机构的确认登记为准。认购/申购申请被确认无效的，认购/申购资金将会退还给投资人。非货币型基金申购、赎回价格以申购、赎回日交易时间结束后，基金注册登记机构公布的基金份额净值为基准，即“未知价”原则。基金交易时间为上海、深圳证券交易所交易时间（9：30～11：30，13：00-15：00），或基金合同规定的其它时间。\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("认购/申购操作步骤:")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        1、登录公司自助式前台业务系统；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        2、点击交易菜单中的“买入基金功能”，列出可购买列表；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        3、选择基金，并选择基金销售支付结算机构以及对应的银行卡，输入认购/申购金额等信息；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        4、认购/申购信息预览；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        5、通过基金销售支付结算机构支付，等待网银返回结果；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        6、支付成功，认购/申购完成。"
                        ),
                        _c("br")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "t" }, [_vm._v("（三）赎回")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        赎回是指投资人申请将基金卖回给基金管理公司的行为。赎回操作步骤:\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        1、登录公司自助式前台业务系统；"
                        ),
                        _c("br"),
                        _vm._v("\n                        2、点击赎回菜单；"),
                        _c("br"),
                        _vm._v(
                          "\n                        3、选择欲赎回的基金产品；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        4、输入需要赎回的基金份额；"
                        ),
                        _c("br"),
                        _vm._v("\n                        5、赎回预览；"),
                        _c("br"),
                        _vm._v(
                          "\n                        6、赎回申请下单成功。"
                        ),
                        _c("br")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        基金管理人应当按时支付赎回款项，但是下列情形除外：\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        1、因不可抗力导致基金管理人不能支付赎回款项；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        2、证券交易场所依法决定临时停市，导致基金管理人无法计算当日基金资产净值；"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        3、基金合同约定的其他特殊情形。\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        每个基金通常设有最低赎回份额限制和最低剩余份额限制。对于不符合赎回限制的申请，部分基金注册登记机构会对该类委托确认失败，部分基金注册登记机构会将剩余份额强制赎回。\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "t" }, [_vm._v("（四）其它")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "投资人还可根据需要，办理开放式基金份额的转换、非交易过户、转托管、冻结等业务。"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-tit",
                      attrs: { slot: "tit" },
                      slot: "tit"
                    },
                    [_vm._v("六、投诉处理和联系方式")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "about-con",
                      attrs: { slot: "con" },
                      slot: "con"
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "（一）基金投资人可以通过拨打我公司客户服务中心电话或以书信、传真、电子邮件等方式，对营业网点所提供的服务提出建议或投诉。对于工作日受理的投诉，原则上当日回复，不能当日回复的，在3个工作日内回复。对于非工作日受理的投诉，原则上在顺延的第一个工作日回复，不能及时回复的，在3个工作日内回复。"
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        （二）基金投资人也可通过书信、传真、电子邮件等方式，向中国证监会和中国证券业协会投诉。联系方式如下： "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        中国证监会辽宁监管局：网址：www.csrc.gov.cn，联系电话：024-22899980 ，传真：024-22899917，电子邮箱：dijw@csrc.gov.cn，地址：沈阳市和平区十一纬路12号，邮编：110003。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        中国证券业协会：网址：www.sac.net.cn，电子邮箱 huizhang@sac.net.cn，地址：北京金融街富凯大厦B座二层，邮编：100140。传真：010-66575896，电话：010-58352888（中国证券投资者呼叫中心）、www.sipf.com(中国证券投资者保护网)。\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "（三）因基金合同而产生的或与基金合同有关的一切争议，如经协商或调解不能解决的，基金投资人可提交中国国际经济贸易仲裁委员会根据当时有效的仲裁规则进行仲裁。仲裁地点为基金合同约定的地点。仲裁裁决是终局的，对各方当事人均有约束力。"
                        ),
                        _c("br"),
                        _vm._v(
                          "投资人在投资基金前应认真阅读《基金合同》、《招募说明书》等基金法律文件，选择与自身风险承受能力相适应的基金。我公司和基金管理人承诺投资人利益优先，以诚实信用、勤勉尽责的态度为投资人提供服务，但不能保证基金一定盈利，也不能保证基金的最低收益。投资人可登录中国证监会网站（www.csrc.gov.cn）或中国证券业协会网站（www.sac.net.cn）查询基金销售机构名录，核实我公司基金销售资格。"
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                        基金销售机构名称:财咨道信息技术有限公司"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        网址：www.jinjiwo.com "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        客户服务中心电话：400-003-5811 "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        地址：辽宁省沈阳市浑南区白塔二南街18-2号B座601 "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        邮编：110169\n                    "
                        )
                      ])
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.type == 4
              ? _c("div", { staticClass: "agreement-con" }, [
                  _c("h1", [_vm._v("基金定期定额交易服务协议")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v("甲方：投资者"),
                    _c("br"),
                    _vm._v("乙方：财咨道信息技术有限公司")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "第一条 依照《中华人民共和国证券投资基金法》、《证券投资基金销售管理办法》等有关法律法规以及乙方代销基金产品的公开法律文件，甲、乙双方在已签订《基金网上交易服务协议》的基础上，现就甲方委托乙方代理开放式基金定期定额业务签订本协议。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "第二条 定期定额业务包括与乙方有基金代销业务合作关系的基金管理公司在乙方已开通定期定额申购业务的基金。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "第三条 甲方可通过网上交易委托系统开通、修改、暂停、终止定期定额业务。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "第四条 甲方在交易时间15：00前申请开通定期定额交易服务，乙方当日即为甲方开通定期定额交易服务；若甲方在交易时间15：00后申请开通定期定额交易服务，乙方则于下个交易日为甲方开通定期定额交易服务。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "第五条 甲方在办理定期定额业务时，了解和授权乙方按照下列规定办理申购申请事项："
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v(
                      "\n                    1、约定基金：甲方申购的基金品种限于乙方代销的已经开通定期定额业务的开放式基金。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    2、约定周期：甲方委托乙方扣款的周期为“每月”，“每周”。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    3、约定周期频率：以月为周期的定期定额计划可以设置的交易发起日期为：1日至28日，以周为周期的定期定额计划可以设置的交易发起日期为：周一至周五。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    4、每期约定金额：甲方每期约定的扣款金额不低于所申购基金公司的定期定额申购金额下限。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    5、扣款截止日：甲方设置定期定额业务的扣款截止日，在开通日至扣款截止日区间内约定的扣款日进行扣款，超过扣款截止日，则该笔业务终止。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    6、风险测试：新开通交易账户的客户需要先通过风险测试，然后办理定期定额业务，客户需要定期或不定期重新进行风险测试。\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "第六条 甲方在办理定期定额业务时，了解和授权乙方按照下列规定办理扣款事项："
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v(
                      "1、为确保每期定期定额申购成功，甲方应保证在扣款当日14:00前用于扣款的银行账户处于正常状态且保留足额金额。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v(
                      "2、扣款顺序：先以签约时间先后顺序扣款，再以余额是否满足扣款条件扣款。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v("\n                    3、顺延扣款的两种情形："),
                    _c("br"),
                    _vm._v(
                      "\n                    1）扣款日期为非基金交易日：以月为周期的定期定额计划遇节假日顺延发起：若定期定额计划指定扣款日遇到节假日，则约定交易顺延至下一个交易日发起。如果计划指定扣款日为月末，且恰逢节假日，该笔定期定额交易将顺延至下月第一个交易日执行。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    2）由于基金公司原因（如基金暂停申购、当日基金累计委托金额超过设定上限等）拒绝接受甲方提交的基金定期定额申购申请的。\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v("\n                    4、失败的处理："),
                    _c("br"),
                    _vm._v(
                      "\n                    1）当扣款日期为非基金交易日时，乙方将在甲方约定扣款日的下个交易日发出扣款指令。若当期扣款失败，乙方将不代理甲方提交该期定期定额申购委托。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    2）若由于甲方账户状态不正常或甲方账户余额不足或委托金额低于定期定额申购下限导致扣款失败连续九期的，视为该笔定期定额业务设置自动终止，表示甲方自动放弃该笔定期定额业务，由此产生的一切后果，由甲方自行承担。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    3）定期定额交易失败不顺延：甲方账户状态不正常、账户余额不足、委托金额低于定期定额申购下限、网络故障、系统故障或不可抗力导致按照定期定额计划发起的交易申请无法成功时，本期定期定额交易申请失效，但不影响之后的定期定额交易。\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v("第七条 定期定额业务委托申请的确认")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v(
                      "\n                    1、乙方仅负责在甲方约定的扣款日进行扣款和上报定期定额委托申请数据，对于最终申购成功与否及确认基金份额，均以该基金注册登记人的确认数据为准。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    2、每期成功扣款日为定期定额业务委托申请实际提交日（T 日），该日基金净值为成交价格，甲方可自基金委托实际提交日后的第二个交易日起（T+2 日）通过乙方网上交易委托系统查询成交记录。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    3、乙方系统按投资者预先设置的定期定额计划自动发起交易申请，该笔交易申请不能撤单。\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v("第八条 定期定额业务的终止")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v(
                      "\n                    1、自行终止，即甲方通过乙方网上交易系统终止定期定额业务。定期定额计划指定交易日当日不允许终止和变更协议。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    2、期满终止，即满足甲方设定的期满条件后，该业务终止。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                    3、违约终止，即由于甲方账户状态不正常或甲方账户余额不足或委托金额低于定期定额申购下限导致扣款失败连续九期的，该业务终止。\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "第九条 对协议中涉及的约定周期、约定日期、期满条件等，乙方同意甲方有权单方面进行调整，一经调整即发生法律效力。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "第十条 甲方需确认在开通定期定额业务前，已详细阅读拟投资基金的基金合同、公开说明书、业务规则及所公告的其他基金信息。乙方仅作为基金公司的代理销售机构，对基金的业绩不承担任何担保和其他经济责任。乙方受理的各类基金交易委托，以该基金注册登记机构的确认结果为准。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "第十一条 本补充协议与《基金网上交易服务协议》具有同等法律效力。本协议未尽事宜，双方应按照《基金网上交易服务协议》的约定执行。"
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.type == 5
              ? _c("div", { staticClass: "agreement-con" }, [
                  _c("h1", [_vm._v("普通投资者信息提示函")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0" }, [
                    _vm._v(
                      "尊敬的投资者，根据《证券期货投资者适当性管理办法》第二十三条的规定，在您购买基金前，请确认您已知晓并接受以下信息。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v("（一）可能直接导致本金亏损的事项；")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v("（二）可能直接导致超过原始本金损失的事项；")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v(
                      "（三）因经营机构的业务或者财产状况变化，可能导致本金或者原始本金亏损的事项；"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v(
                      "（四）因经营机构的业务或者财产状况变化，影响客户判断的重要事由；"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v(
                      "（五）限制销售对象权利行使期限或者可解除合同期限等全部限制内容，已详细阅读基金合同和招募说明书等法律文件。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ti0 sub" }, [
                    _vm._v(
                      "（六）经营机构根据投资者分类、产品分级和适当性匹配结果提供适当性匹配意见。当经营机构告知投资者不适合购买相关产品后，投资者主动要求购买风险等级高于其风险承受能力产品的，经营机构在确认其不属于风险承受能力最低类别的投资者后，在就产品风险高于其承受能力进行特别的书面风险警示，投资者仍坚持购买的，可以向其销售相关产品。同时经营机构及工作人员没有在基金销售过程中主动推介该基金。"
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c("button", { staticClass: "btn", on: { click: _vm.close } }, [
              _vm._v("确定")
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2681052a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2681052a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement.vue
// module id = AxkB
// module chunks = 1 3